import { Navigate, Route, Routes } from 'react-router-dom'
import { RecordPage } from './RecordPage'
import { NewUserPage } from './NewUserPage'
import { SettingsPage } from './SettingsPage'
import { WhitelistPage } from './WhitelistPage'
import { PatientDetailsPage } from './PatientDetailsPage'
import { BackOfficePage } from './BackOfficePage'
import AuthenticationService from '../services/AuthenticationService'
import { PatientSelectPage } from './PatientSelectPage'
import { FourOhFour } from './FourOhFourPage'
import { StatisticsPage } from './StatisticsPage'
import UserListPage from './AdminToolsPage/UserListPage'
import PracticeListPage from './AdminToolsPage/PracticeListPage'
import LocationListPage from './AdminToolsPage/LocationListPage'
import AdminToolsPage from './AdminToolsPage'
import PsychologistListPage from './AdminToolsPage/PsychologistListPage'
import InsurerListPage from './AdminToolsPage/InsurerListPage'
import TreatmentProgramListPage from './AdminToolsPage/TreatmentProgramListPage'
import DossierCleanupPage from './AdminToolsPage/DossierCleanupPage'
import TimeRegistrationStatsPage from './AdminPage/TimeRegistrationStatsPage'
import RegisteredActivitiesPage from './AdminPage/RegisteredActivitiesPage'
import AggregatedActivitiesPage from './AdminPage/AggregatedActivitiesPage'
import AverageHoursPage from './AdminPage/AverageHoursPage'

const PageRoutes = () => {
  return (
    <Routes>
      <Route path="/clienten" element={<PatientSelectPage />} />
      <Route
        path="/wachtlijst/:funnelId"
        element={<PatientDetailsPage />}
      />
      <Route
        path="/clienten/:patientId/trajecten/:treatmentProgramId"
        element={<RecordPage />}
      />
      <Route path="/instellingen" element={<SettingsPage />} />
      <Route path="/wachtlijst" element={<BackOfficePage />} />
      <Route path="/gebruikers/toevoegen" element={<NewUserPage />} />
      <Route path="/whitelist" element={<WhitelistPage />} />
      <Route path="/statistieken" element={<StatisticsPage />} />
      <Route path="/userlist" element={<UserListPage />} />
      <Route path="/practicelist" element={<PracticeListPage />} />
      <Route path="/locationlist" element={<LocationListPage />} />
      <Route path="/admin-tools" element={<AdminToolsPage />} />
      <Route path="/psychologistlist" element={<PsychologistListPage />} />
      <Route path="/insurerlist" element={<InsurerListPage />} />
      <Route path="/treatmentprogramlist" element={<TreatmentProgramListPage />} />
      <Route path="/dossier-cleanup" element={<DossierCleanupPage />} />
      <Route path="/time-registration-stats" element={<TimeRegistrationStatsPage />} />
      <Route path="/registered-activities" element={<RegisteredActivitiesPage />} />
      <Route path="/aggregated-activities" element={<AggregatedActivitiesPage />} />
      <Route path="/average-hours" element={<AverageHoursPage />} />
      <Route
        path="/"
        element={
          AuthenticationService.isBackOffice() ? (
            <Navigate
              to="/wachtlijst"
              replace
            />
          ) : (
            <Navigate
              to="/clienten"
              replace
            />
          )
        }
      />
      <Route path="*" element={<FourOhFour />} />
    </Routes>
  )
}

export default PageRoutes
